'use client';
import { isArray, isString } from '@s7/utils';

var getMs = function(time) {
    return isArray(time) ? time.join(", ") : isString(time) ? time : "" + time + "ms";
};
var transition = function(theme) {
    return function(options) {
        var _ref = options || {}, _ref_props = _ref.props, props = _ref_props === void 0 ? [
            "all"
        ] : _ref_props, _ref_fn = _ref.fn, fn = _ref_fn === void 0 ? theme.timingFunction : _ref_fn, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 200 : _ref_duration;
        return {
            transitionTimingFunction: isArray(fn) ? fn.join(", ") : fn,
            transitionProperty: isArray(props) ? props.join(", ") : props,
            transitionDelay: isArray(delay) ? delay.map(getMs).join(", ") : getMs(delay),
            transitionDuration: isArray(duration) ? duration.map(getMs).join(", ") : getMs(duration)
        };
    };
};

export { transition };
